<div class="sales-list">
    @if (marketSalesDataService.estateSaleIsLoading()) {
        <div class="list-loading">
            <ev-logo-loader width="70px" label="Henter salg" />
        </div>
    } @else {
        @if (sales() != null && sales().length > 0) {
            <div class="sort-wrapper">
                <div class="header">Sorter på</div>
                <div class="drop-down-wrapper">
                    <ev-dropdown-menu #searchResultDropDownCmp
                        class="filter-dropdown"
                        [items]="filterOptions()"
                        [fromRight]="true"
                        [alwaysShow]="true"
                        [asDotted]="false"
                        [showHeader]="false"
                        [showSubInSelected]="true"
                        [useBoxShadow]="false"
                        [theme]="'monochrome'"
                        [top]="'90px'"
                        (onSelectedItem)="setFilter($event)"
                    >
                    </ev-dropdown-menu>
                </div>
            </div>

            @for (sale of sales(); track $index) {
                <estate-sale-item [sale]="sale"></estate-sale-item>
            }
        }
    }
</div>
